/** Estimating department id — matches auth.departments / resourceAccess. */
export const ESTIMATING_DEPARTMENT_ID = 3;

/** Lead authority hierarchy (lower = more senior). Lead = 30. */
export const LEAD_AUTHORITY_HIERARCHY = 30;

const TC_ROLE_IDS = new Set(['tc', 'construction_technical_coordinator']);

/**
 * Estimating department + Lead (or more senior). Same identity used for
 * Format Builder / MTO bid-close “lead estimator”.
 */
export function isLeadEstimator(info) {
  if (!info) return false;
  const depts = info.allDepartmentIds || [];
  const inEstimating = depts.some((id) => Number(id) === ESTIMATING_DEPARTMENT_ID);
  const level = Number(info.roleLevel);
  return inEstimating && Number.isFinite(level) && level <= LEAD_AUTHORITY_HIERARCHY;
}

function secondaryRoleIds(info) {
  const secondary = info.secondaryRoles || info.secondary_roles || [];
  if (!Array.isArray(secondary)) return [];
  return secondary
    .map((sr) => sr?.role_id || sr?.id || sr)
    .filter((id) => typeof id === 'string');
}

/** Primary or secondary Technical Coordinator. */
export function isTechnicalCoordinator(info) {
  if (!info) return false;
  if (info.isTC) return true;
  if (TC_ROLE_IDS.has(info.roleName) || TC_ROLE_IDS.has(info.roleId)) return true;
  return secondaryRoleIds(info).some((id) => TC_ROLE_IDS.has(id));
}

/**
 * Who can open Budget Hours Baseline (and job-level EVM).
 * System / reports.project (Manager+) plus Lead Estimator and Technical Coordinators.
 */
export function canAccessBudgetBaseline(info) {
  if (!info) return false;
  if (info.isAdmin) return true;
  const perms = info.permissions || [];
  if (perms.includes('reports.project')) return true;
  if (isLeadEstimator(info)) return true;
  return isTechnicalCoordinator(info);
}

/**
 * Job-level EVM / Resource Control page.
 * Same people as Budget Hours Baseline, plus an explicit evm-report menu grant.
 */
export function canAccessEvmReport(info) {
  if (canAccessBudgetBaseline(info)) return true;
  const menu = info?.menuItems || [];
  return menu.includes('evm-report');
}
